// extracted by mini-css-extract-plugin
module.exports = {"note":"Note_note__3BIZ6","noteAutoPlay":"Note_noteAutoPlay__31R4y Note_note__3BIZ6"};